import dynamic from "next/dynamic"
import Head from "next/head";

const Quote2 = dynamic(() => import("@components/Components/CheckoutComponent/Quote/Quote"), {
  ssr: false,
})

const Quote = ({quoteData}) => {

  const {template_page_settings} = quoteData;

  return (
    <>
      <Head>
        <title>{`${process.env.brand.brand_name} - Checkout - Quote`}</title>
        <meta
            name="description"
            content={`${process.env.brand.brand_name} offer furniture hire, chair hire and table hire at exceptional prices throughout London and the UK. Order online now.`}
        />
      </Head>

      {/* <QuoteComponent
        template_page_settings={template_page_settings}
      /> */}
      <Quote2
        template_page_settings={template_page_settings}
      />
    
    </>
  )

}


export async function getServerSideProps({query, res}) {
  const quoteReq = await fetch(`${process.env.BASE_API_URL}checkout/quote`);
  const quoteData = await quoteReq.json()

  // Pass data to the page via props
  return { 
    props: { quoteData },
  }
}

export default Quote